import moment from 'moment';
import { numberFormat } from '../../../../utils/helpers/number_formatter';
import { convertMillsToDollars, currencyFormat } from '../../../../utils/helpers/currency';
import { currencyFields } from '../../../../utils/constants';

export const columnWidth = (field, columnAttributes) => {
  switch (columnAttributes[field]) {
    case 'identifier':
      switch (field) {
        case 'uuid':
        case 'referencenumber':
          return '180'
        default:
          return '100'
      }
    case 'datetime':
      return '240';
    default:
      return '200';
  }
};

export const formatData = (field, columnAttributes, column, _row) => {
  switch (columnAttributes[field]) {
    case 'datetime':
      return column ? moment(column).utc().format('MMMM Do[,] YYYY') : column;
    case 'integer':
    case 'float':
    case 'decimal':
      return currencyFields.includes(field) ? currencyFormat(convertMillsToDollars(column)) : numberFormat(column);
    default: {
      return column;
    }
  }
};

